// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footer-container--YuirX";
export var footerIcons = "footer-module--footer-icons--EwmRM";
export var footerTop = "footer-module--footerTop--M11eD";
export var footerTopSecond = "footer-module--footerTopSecond--AYt1a";
export var footerBottom = "footer-module--footerBottom--rTu3w";
export var footerLogo = "footer-module--footerLogo--C0TNh";